import { DropdownData } from '@zayan-erp/shared';
import { createReducer, on } from '@ngrx/store';
import * as WarrantyActions from './warranty.actions';

export interface WarrantyState {
  warrantyTypes: DropdownData[];
  deficiencyCode: DropdownData[];
  locations: DropdownData[];
  categoryId: string | null;
  categoryLocation: { [categoryLocation: string]: DropdownData[] };
}

export const initialWarrantyState: WarrantyState = {
  warrantyTypes: [],
  deficiencyCode: [],
  locations: [],
  categoryId: null,
  categoryLocation: {}
};

export const warrantyReducer = createReducer(
  initialWarrantyState,
  on(WarrantyActions.loadWarrantyTypesSuccess, (state, { warrantyTypes }) => ({
    ...state,
    warrantyTypes
  })),

  on(WarrantyActions.loadDeficiencyCodeSuccess, (state, { deficiencyCode }) => ({
    ...state,
    deficiencyCode
  })),

  on(WarrantyActions.loadLocationsSuccess, (state, { locations }) => ({
    ...state,
    locations
  })),

  on(WarrantyActions.selectedCategoryId, (state, { categoryId }) => ({
    ...state,
    categoryId
  })),

  on(WarrantyActions.loadCategoryLocation, (state, { categoryLocation }) => ({
    ...state,
    categoryLocation: { ...state.categoryLocation, ...categoryLocation }
  }))
);
